// FETCH ALL PROPERTIES FROM STATE MASTER
export const FETCH_STATE_MASTER_REQUEST = 'FETCH_STATE_MASTER_REQUEST';
export const FETCH_STATE_MASTER_SUCCESS = 'FETCH_STATE_MASTER_SUCCESS';
export const FETCH_STATE_MASTER_FAILURE = 'FETCH_STATE_MASTER_FAILURE';

// CREATE PROPERTIES FOR STATE MASTER
export const CREATE_STATE_MASTER_REQUEST = 'CREATE_STATE_MASTER_REQUEST';
export const CREATE_STATE_MASTER_SUCCESS = 'CREATE_STATE_MASTER_SUCCESS';
export const CREATE_STATE_MASTER_FAILURE = 'CREATE_STATE_MASTER_FAILURE';

// UPDATE PROPERTIES FOR STATE MASTER
export const UPDATE_STATE_MASTER_REQUEST = 'UPDATE_STATE_MASTER_REQUEST';
export const UPDATE_STATE_MASTER_SUCCESS = 'UPDATE_STATE_MASTER_SUCCESS';
export const UPDATE_STATE_MASTER_FAILURE = 'UPDATE_STATE_MASTER_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_STATE_MASTER_REQUEST = 'FETCH_SINGLE_STATE_MASTER_REQUEST';
export const FETCH_SINGLE_STATE_MASTER_SUCCESS = 'FETCH_SINGLE_STATE_MASTER_SUCCESS';
export const FETCH_SINGLE_STATE_MASTER_FAILURE = 'FETCH_SINGLE_STATE_MASTER_FAILURE';

// DELETE PROPERTIES FOR STATE MASTER
export const DELETE_STATE_MASTER_REQUEST = 'DELETE_STATE_MASTER_REQUEST';
export const DELETE_STATE_MASTER_SUCCESS = 'DELETE_STATE_MASTER_SUCCESS';
export const DELETE_STATE_MASTER_FAILURE = 'DELETE_STATE_MASTER_FAILURE';

// USERFORM RESET

export const STATE_MASTER_USERFORM_RESET = 'STATE_MASTER_USERFORM_RESET';
export const CREATE_USER_FORM_STATE_MASTER = 'CREATE_USER_FORM_STATE_MASTER';
